import preset from "../preset";

export type col_span = number;

export const colSpanClass = preset.xclasses<col_span>('colSpan');

export default colSpanClass;
